/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import ApercuRegularEot from 'src/assets/fonts/apercu-regular.eot';
import ApercuRegularWoff2 from 'src/assets/fonts/apercu-regular.woff2';
import ApercuRegularWoff from 'src/assets/fonts/apercu-regular.woff';
import ApercuRegularTtf from 'src/assets/fonts/apercu-regular.ttf';

import ApercuBoldEot from 'src/assets/fonts/apercu-bold.eot';
import ApercuBoldWoff2 from 'src/assets/fonts/apercu-bold.woff2';
import ApercuBoldWoff from 'src/assets/fonts/apercu-bold.woff';
import ApercuBoldTtf from 'src/assets/fonts/apercu-bold.ttf';

import TiemposHeadlineMedium from 'src/assets/fonts/TiemposHeadline-Medium.otf';
import TiemposHeadlineMediumItalic from 'src/assets/fonts/TiemposHeadline-MediumItalic.otf';
import TiemposHeadlineRegular from 'src/assets/fonts/TiemposHeadline-Regular.otf';
import TiemposHeadlineRegularItalic from 'src/assets/fonts/TiemposHeadline-RegularItalic.otf';

import { createGlobalStyle } from 'styled-components';
import { colors, fontFamilyNormal } from '@coop/ole/styles';

const GlobalStyles = createGlobalStyle`
	@font-face {
		font-family: 'TiemposHeadlineMedium';
		src: local("Tiempos Headline Medium"),
			url(${TiemposHeadlineMedium});
		font-weight: normal;
		font-style: normal;
		font-display: swap;
  }

  @font-face {
		font-family: 'TiemposHeadlineMediumItalic';
		src: local("Tiempos Headline Italic"),
			url(${TiemposHeadlineMediumItalic});
		font-weight: normal;
		font-style: normal;
		font-display: swap;
  }


  @font-face {
		font-family: 'TiemposHeadlineRegular';
		src: local("Tiempos Headline Regular"),
			url(${TiemposHeadlineRegular});
		font-weight: normal;
		font-style: normal;
		font-display: swap;
  }


  @font-face {
		font-family: 'TiemposHeadlineRegularItalic';
		src: local("Tiempos Headline Regular Italic"),
			url(${TiemposHeadlineRegularItalic});
		font-weight: normal;
		font-style: normal;
		font-display: swap;
  }


  @font-face {
		font-family: 'ApercuRegular';
		src: local("Apercu"),
			url('${ApercuRegularEot}');
		src: local("Apercu"),
			url('${ApercuRegularWoff2}') format('woff2'),
			url('${ApercuRegularWoff}') format('woff'),
			url('${ApercuRegularTtf}') format('truetype');
		font-weight: normal;
		font-style: normal;
		font-display: swap;
	}

	@font-face {
		font-family: 'ApercuBold';
		src: local("Apercu Bold"),
			url('${ApercuBoldEot}');
		src: local("Apercu Bold"),
			url('${ApercuBoldWoff2}') format('woff2'),
			url('${ApercuBoldWoff}') format('woff'),
			url('${ApercuBoldTtf}') format('truetype');
		font-weight: normal;
		font-style: normal;
		font-display: swap;
	}
  * {
    box-sizing: border-box;
  }

  body {
    color: ${colors.grey100};
    margin: 0;
    background-color: ${colors.white};
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    font-family: ${fontFamilyNormal};
  }

	.grecaptcha-badge { visibility: hidden; }
`;

export default GlobalStyles;
